import { defineStore } from "pinia";
import { Facet, Pill } from "../services/models/search.models";

export const useProductFilterStore = defineStore("productFilter", {
    state: () => ({
        filters: [] as Facet[], // Full list of filters (facets)
        selectedFilters: [] as Pill[], // List of selected filters (pills)
        totalHits: 0, // Total number of hits (products) found
        showFacets: false, // Flag to show/hide facets/filter panel
        isLoading: false, // Flag to indicate loading state
    }),
    actions: {
        addFilter(pill: Pill) {
            this.selectedFilters.push(pill);
        },
        removeFilter(pill: Pill) {
            const index = this.selectedFilters.findIndex(
                (p) =>
                    p.facetId === pill.facetId &&
                    p.facetValueId === pill.facetValueId,
            );
            if (index !== -1) {
                this.selectedFilters.splice(index, 1);
            }
        },
        toggleFilter(pill: Pill) {
            const index = this.selectedFilters.findIndex(
                (p) =>
                    p.facetId === pill.facetId &&
                    p.facetValueId === pill.facetValueId,
            );
            if (index !== -1) {
                this.selectedFilters.splice(index, 1);
            } else {
                this.selectedFilters.push(pill);
            }
        },
        clearFilters() {
            this.selectedFilters = [];
        },
        toggleShowFacets() {
            this.showFacets = !this.showFacets;
        },
    },
    getters: {
        selectedFiltersCount: (state) => {
            return state.selectedFilters.length;
        },
    },
});